module.exports = __webpack_public_path__ + "static/img/ic_monthly_salary.394ef54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welfare/ic_monthly_salary.png
// module id = NjFe
// module chunks = 1